import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss'
import * as classNames from 'classnames';
import Image from './Image';

export type DiaporamaProps = {
    images: PictureRef[]
};

const styles = {
    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },
    slide: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        opacity: 0,
        transition: 'opacity .3s ease',
    },
    slideActive: {
        opacity: 1,
    },
    nextImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        cursor: ' e-resize',
        zIndex: 9
    },
    linkInactve: {
        cursor: 'initial'
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        objectPosition: 'bottom left'
    },
}
type Props =
    DiaporamaProps &
    StyledComponentProps<keyof typeof styles>;

type State = {
    current: number
};

class Diaporama extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this._Next = this._Next.bind(this);

        this.state = {
            current: 0
        }
    }
    public render() {
        const { classes, images } = this.props;
        const { current } = this.state;

        return (
            <div className={classNames(classes!.container)}>
                <a
                    className={classes!.nextImage}
                    onClick={this._Next}
                />
                {images.length >= 1 ?
                    images.map((image, i) =>
                        <div
                            className={classNames(classes!.slide,
                                current === i ? classes!.slideActive : null)}
                            key={`picture-${i}`}
                        >
                            <Image
                                pictureRef={image}
                                className={classes!.image}
                                // tslint:disable-next-line:max-line-length
                                sizes="(max-width: 600px) 100vw, (min-width: 601px) 60vw"
                            />
                        </div>
                    ) : <div>No images to render</div>}
            </div>
        );
    }
    private _Go(i: number) {
        const { images } = this.props;

        this.setState(() => ({
            current: i % images.length
        }));
    }

    private _Next() {
        const { current } = this.state;

        this._Go(current + 1);
    }
}

export default withStyles(styles)(Diaporama);


// WEBPACK FOOTER //
// ./src/Components/Diaporama.tsx